import { Checkbox, Collapse } from 'antd';
import { TemplateConfig } from '../../../Templar/RenderPdfPrescription';
import { AntTooltip } from '../../../components/common/AntTooltip';
const { Panel } = Collapse;

const ExaminationFindings: React.FC<{
    rxConfig: TemplateConfig | undefined;
    saveRxConfigInState: (rxObj: TemplateConfig) => void;
    sectionName?: string;
}> = ({ rxConfig, saveRxConfigInState, sectionName }) => {
    return (
        <Collapse
            expandIcon={() => (
                <div className="rounded-4 min-w-26 h-26 flex items-center justify-center bg-darwin-accent-examination-findings-sky-blue-900">
                    <div className="w-full h-full flex items-center justify-center">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 13 13"
                            className="w-16 h-16 fill-white"
                        >
                            <path d="M11.0389 3.125C9.98418 3.125 9.16387 3.96875 9.16387 5C9.16387 5.77344 9.60918 6.42969 10.2889 6.73438V8.58594C10.2889 9.92188 9.09355 11.0234 7.66387 11.0234C6.25762 11.0234 5.08574 9.96875 5.03887 8.67969C6.72637 8.32812 8.03887 6.82812 8.03887 5V1.36719C8.03887 1.10938 7.82793 0.875 7.57012 0.828125L6.09355 0.523438C5.78887 0.453125 5.50762 0.664062 5.4373 0.96875L5.36699 1.32031C5.29668 1.625 5.50762 1.92969 5.8123 2L6.51543 2.14062V4.97656C6.51543 6.21875 5.53105 7.25 4.28887 7.25C3.04668 7.27344 2.01543 6.26562 2.01543 5V2.14062L2.74199 2C3.04668 1.92969 3.25762 1.64844 3.1873 1.34375L3.11699 0.96875C3.04668 0.664062 2.76543 0.453125 2.46074 0.523438L0.984178 0.804688C0.726365 0.875 0.538865 1.10938 0.538865 1.36719V5C0.538865 6.82812 1.82793 8.32812 3.53887 8.67969C3.58574 10.8125 5.41387 12.5 7.66387 12.5C9.9373 12.5 11.7889 10.7422 11.7889 8.5625V6.73438C12.4451 6.42969 12.9139 5.77344 12.9139 5.02344C12.9139 3.96875 12.0701 3.125 11.0389 3.125ZM11.0389 5.5625C10.7107 5.5625 10.4764 5.32812 10.4764 5C10.4764 4.69531 10.7107 4.4375 11.0389 4.4375C11.3436 4.4375 11.6014 4.69531 11.6014 5C11.6014 5.32812 11.3436 5.5625 11.0389 5.5625Z"></path>
                        </svg>
                    </div>
                </div>
            )}
        >
            <Panel
                header={<div className="font-700">{sectionName || 'Examination Findings'}</div>}
                key="1"
            >
                <p className="mr-16 space-y-4">
                    <div className="cursor-pointer">
                        <p
                            className="cursor-pointer flex flex-1 items-center justify-between"
                            onClick={() => {
                                saveRxConfigInState({
                                    examination_findings_name_in_unbold: !rxConfig?.examination_findings_name_in_unbold,
                                });
                            }}
                        >
                            <span>Make the examination findings name bold</span>
                            <Checkbox
                                checked={!rxConfig?.examination_findings_name_in_unbold}
                            ></Checkbox>
                        </p>
                    </div>
                    <div className="cursor-pointer">
                        <p
                            className="cursor-pointer flex flex-1 items-center justify-between"
                            onClick={() => {
                                saveRxConfigInState({
                                    bullets_config: {
                                        ...rxConfig?.bullets_config,
                                        ['examinations']: !rxConfig?.bullets_config?.[
                                            'examinations'
                                        ],
                                    },
                                });
                            }}
                        >
                            <span>Use bullet points</span>
                            <Checkbox
                                checked={rxConfig?.bullets_config?.['examinations']}
                            ></Checkbox>
                        </p>
                    </div>
                    <div className="border-b border-darwin-neutral-200 mx-8"></div>
                    <div className="flex items-center justify-between">
                        <div>Heading</div>{' '}
                        <div className="flex space-x-12">
                            <input
                                type="color"
                                id="head"
                                name="head"
                                value={rxConfig?.examinations_heading_color || '#2188FF'}
                                onChange={(e) => {
                                    saveRxConfigInState({
                                        examinations_heading_color: e.target.value,
                                    });
                                }}
                                className="circular-color-input"
                            />

                            <AntTooltip content="Reset">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                    onClick={() => {
                                        saveRxConfigInState({
                                            examinations_heading_color: '',
                                        });
                                    }}
                                >
                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                </svg>
                            </AntTooltip>
                        </div>
                    </div>
                    <div className="flex items-center justify-between">
                        <div>Key Elements</div>{' '}
                        <div className="flex space-x-12">
                            <input
                                type="color"
                                id="head"
                                name="head"
                                value={rxConfig?.examinations_name_color || '#000000'}
                                onChange={(e) => {
                                    saveRxConfigInState({
                                        examinations_name_color: e.target.value,
                                    });
                                }}
                                className="circular-color-input"
                            />

                            <AntTooltip content="Reset">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                    onClick={() => {
                                        saveRxConfigInState({
                                            examinations_name_color: '',
                                        });
                                    }}
                                >
                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                </svg>
                            </AntTooltip>
                        </div>
                    </div>
                    <div className="flex items-center justify-between">
                        <div>Properties</div>{' '}
                        <div className="flex space-x-12">
                            <input
                                type="color"
                                id="head"
                                name="head"
                                value={rxConfig?.examinations_properties_color || '#000000'}
                                onChange={(e) => {
                                    saveRxConfigInState({
                                        examinations_properties_color: e.target.value,
                                    });
                                }}
                                className="circular-color-input"
                            />

                            <AntTooltip content="Reset">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                    onClick={() => {
                                        saveRxConfigInState({
                                            examinations_properties_color: '',
                                        });
                                    }}
                                >
                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                </svg>
                            </AntTooltip>
                        </div>
                    </div>
                </p>
            </Panel>
        </Collapse>
    );
};

export default ExaminationFindings;
